'use client';

import { PageClientImpl } from './PageClientImpl';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { db } from '@/lib/firebase.config';
import { doc, getDoc } from 'firebase/firestore';
import { VideoCodec } from 'livekit-client';

interface UserData {
  firstName?: string;
  email?: string;
  status?: string;
}

export default function Room({ params }: { params: { roomName: string } }) {
  const searchParams = useSearchParams();
  const decodedEmail = decodeURIComponent(params.roomName);
  
  const [userData, setUserData] = useState<UserData>({ 
    firstName: decodedEmail.split('@')[0],
    email: decodedEmail 
  });
  const [loading, setLoading] = useState(true);
  const hq = searchParams.get('hq') === 'true';
  const codec = (searchParams.get('codec') || 'vp8') as VideoCodec;

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userDoc = await getDoc(doc(db, 'users', decodedEmail));
        
        if (userDoc.exists()) {
          const data = userDoc.data();
          setUserData({
            firstName: data.firstName,
            email: decodedEmail,
            status: data.status
          });
        } else {
          console.log('No user found with email:', decodedEmail);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [decodedEmail]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <PageClientImpl
      roomName={decodedEmail}
      hq={hq}
      codec={codec}
      userData={userData}
    />
  );
} 


